$( document ).ready( function(){
  var n = 0;
  $('.aside-container .nav-container .categories.tags ul li').each( function(){ 

      if ( n >= 20 ) {
          $(this).addClass('hide_me');
      }else{
        $(this).removeClass('hide_me');
      }
      n++;
  });
  var n = 0;
  $('.mobile-aside-container .nav-container .categories.tags ul li').each( function(){ 

      if ( n >= 20 ) {
          $(this).addClass('hide_me');
      }else{
        $(this).removeClass('hide_me');
      }
      n++;
  });
  $('.aside-container .nav-container .categories.tags ul,.mobile-aside-container .nav-container .categories.tags ul').append('<li><a href="#" class="load_more">Load More</a></li>');
  $( document ).on( 'click' ,'.load_more', function() {
    $('.hide_me').attr('style','display:inline-block;');
    $(this).removeClass('load_more');
    $(this).addClass('hide_load_more');
    $(this).html('Hide');
    return false;
  });
  $( document ).on( 'click' ,'.hide_load_more', function() {
    $('.hide_me').hide();
    $(this).removeClass('hide_load_more');
    $(this).addClass('load_more');
    $(this).html('Load More');
    return false;
  });
});